import { GET_USER_PREFERENCES_SUCCESS, SET_TAB_FILTERS } from './userPreferences.type';
import { LOG_OUT } from '../auth/auth.types';

const initialState = {
    /** Saved filter state keyed by `UserPreferenceTab`. Tabs never filtered are absent. */
    filters: {},
    /**
     * Whether the bootstrap read has settled — success OR failure.
     *
     * The restore gate blocks a grid from rendering until this flips, so it must
     * never stay false after a failed read or the grid would hang on a preference
     * nobody waits on. A failed read means "no saved filters", not "try forever".
     */
    loaded: false,
};

export const userPreferencesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_PREFERENCES_SUCCESS:
            return {
                ...state,
                filters: action.payload?.filters || {},
                loaded: true,
            };

        case SET_TAB_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.payload.tab]: action.payload.filters,
                },
            };

        // Preferences are per user, and logout does not reload the page — without this
        // the next user to sign in on this tab inherits the previous user's grids.
        case LOG_OUT:
            return initialState;

        default:
            return state;
    }
};
